import React, { useState } from "react";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Text,
  Flex,
  HStack,
  Input,
  Button
} from "@chakra-ui/react";
import { useAppContext } from "../../contexts/AppContext";
import { useNavigate } from "react-router-dom";
import TableFilters from "../general/TableFilters";
import { Plus } from "lucide-react";

const InvestorsTable = ({ fund }) => {
  const { formatDate, tableSize, formatMillions } = useAppContext();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({});

  const labelMap = {
    status: "Status",
  };
  const filterOptions = {
    status: ["Pending", "Approved"],
  };

  const investors = fund?.investorsTable || [];
  const currency = fund?.fundCurrency?.ISO || "N/A";

  const handleRowClick = (investorName) => {
    const formattedInvestorName = investorName.replace(/ /g, "-");
    const formattedFundName = fund.fundName.replace(/ /g, "-");
    const url = `/funds/${formattedFundName}/investor/${formattedInvestorName}`;
    navigate(url);
  };

  // ✅ Appliquer recherche + filtre
  const filteredInvestors = investors.filter((investor) => {
    const matchesSearch = investor.investorName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesStatus =
      !filters.status ||
      filters.status.length === 0 ||
      filters.status.includes(investor.status);

    return matchesSearch && matchesStatus;
  });

  return (
    <Flex direction="column" gap={8}>
      <Flex gap={2} flex={1} justifyContent={"space-between"}>
        <HStack>
          <Input
            placeholder="Search by investor name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            flex={1}
            w={"260px"}
          />
          <TableFilters
            filters={filters}
            setFilters={setFilters}
            filterOptions={filterOptions}
            labelMap={labelMap}
          />
        </HStack>
        <Button leftIcon={<Plus size={16} />}>Add an investment</Button>
      </Flex>

      <TableContainer>
        <Table variant="simple" size={tableSize}>
          <Thead>
            <Tr>
              <Th>Investor Name</Th>
              <Th>Initial Subscription Date</Th>
              <Th>Status</Th>
              <Th>Called Capital %</Th>
              <Th isNumeric>Called Capital</Th>
              <Th isNumeric>Total Commitment</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredInvestors.length > 0 ? (
              filteredInvestors.map((investor, index) => (
                <Tr key={index} onClick={() => handleRowClick(investor.investorName)}>
                  <Td fontWeight={500}>{investor.investorName}</Td>
                  <Td>
                    <Badge colorScheme="blue">
                      {investor.initialSubscriptionDate
                        ? formatDate(investor.initialSubscriptionDate)
                        : "N/A"}
                    </Badge>
                  </Td>
                  <Td>
                    <Badge colorScheme={investor.status === "Approved" ? "green" : "red"}>
                      {investor.status}
                    </Badge>
                  </Td>
                  <Td>{investor.calledCapitalPercentage || 0}%</Td>
                  <Td isNumeric>
                    {currency}{" "}
                    {investor.calledCapital
                      ? formatMillions(investor.calledCapital)
                      : "0"}
                  </Td>
                  <Td isNumeric>
                    {currency}{" "}
                    {investor.totalCommitment
                      ? formatMillions(investor.totalCommitment)
                      : "0"}
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan="6">
                  <Text textAlign="center" py={10} color="gray.500">
                    No investors match your filters.
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  );
};

export default InvestorsTable;
